// Wallet Block API Functions
// Feature: Wallet Blocking System
// API client for wallet block operations

import { apiClient } from './client';

export interface BlockResponse {
  success: boolean;
  message: string;
  block?: {
    id: string;
    user_id: string;
    blocked_address: string;
    created_at: string;
  };
  alreadyBlocked?: boolean;
}

export interface UnblockResponse {
  success: boolean;
  message: string;
  wasBlocked: boolean;
}

export interface BlockStatusResponse {
  success: boolean;
  address: string;
  isBlocked: boolean;
}

export interface BlockedListResponse {
  success: boolean;
  blocked: Array<{
    id: string;
    user_id: string;
    blocked_address: string;
    created_at: string;
  }>;
  pagination: {
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
}

/**
 * Block a wallet address
 */
export async function blockWallet(address: string): Promise<BlockResponse> {
  return apiClient.post<BlockResponse>('/wallet-blocks/block', { address });
}

/**
 * Unblock a wallet address
 */
export async function unblockWallet(address: string): Promise<UnblockResponse> {
  return apiClient.post<UnblockResponse>('/wallet-blocks/unblock', { address });
}

/**
 * Check if authenticated user has blocked a specific wallet
 */
export async function getBlockStatus(address: string): Promise<BlockStatusResponse> {
  return apiClient.get<BlockStatusResponse>(`/wallet-blocks/status/${address}`);
}

/**
 * Get paginated list of wallets the authenticated user has blocked
 */
export async function getBlocked(options?: { limit?: number; offset?: number }): Promise<BlockedListResponse> {
  const params = new URLSearchParams();
  if (options?.limit) params.set('limit', String(options.limit));
  if (options?.offset) params.set('offset', String(options.offset));
  const query = params.toString();
  return apiClient.get<BlockedListResponse>(`/wallet-blocks/blocked${query ? `?${query}` : ''}`);
}
